import type { State } from '../../reducers/types.tsx';

export const getPersisted = (state: State) => state.persisted;

export const getFieldInitialization = (state: State) => state.fieldInitialization;

export const getInitialAppProps = (state: State) => state.initialAppProps;
